import { create } from 'zustand'

interface GlobalSidebarState {
  /**
   * The pointer, keyboard focus, or a text box being typed in is in a table
   * list (the rail's drawer or the Tables panel). Read without subscribing
   * (the list holds a Recency re-sort until it turns false), so changing it
   * re-renders nothing.
   */
  drawerInUse: boolean
  setDrawerInUse: (inUse: boolean) => void
  /** A sidebar row is being dragged; the drawer stays open until it drops. */
  rowDragActive: boolean
  setRowDragActive: (active: boolean) => void
  /** The table whose pages are open, so only its row re-renders on navigation. */
  activeTableId: string | null
  setActiveTableId: (tableId: string | null) => void
}

export const useGlobalSidebarStore = create<GlobalSidebarState>((set) => ({
  drawerInUse: false,
  setDrawerInUse: (drawerInUse) =>
    set((state) => (state.drawerInUse === drawerInUse ? state : { drawerInUse })),
  rowDragActive: false,
  setRowDragActive: (rowDragActive) =>
    set((state) => (state.rowDragActive === rowDragActive ? state : { rowDragActive })),
  activeTableId: null,
  setActiveTableId: (activeTableId) =>
    set((state) => (state.activeTableId === activeTableId ? state : { activeTableId })),
}))
